/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Summary_To_ComeInputs */



/**
* | output |
* | --- |
* | "{count} more bills still to come this month" |
*
* @param {Partner_Summary_To_ComeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_to_come = /** @type {((inputs: Partner_Summary_To_ComeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_To_ComeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} weitere Rechnungen folgen noch in diesem Monat`)
	return /** @type {LocalizedString} */ (`${i?.count} more bills still to come this month`)
});